import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import GoalSettingsViewQuery, {
  GoalSettingsViewQuery as GoalSettingsViewQueryType,
} from '../components/GoalSettings/__generated__/GoalSettingsViewQuery.graphql';

export const goalSettingsPageResource = createRelayResource<GoalSettingsViewQueryType>({
  getQuery: (_routerContext, resourceContext) => {
    const context = resourceContext as ResourceContext;

    const fieldListTql = tqlQueryFromInput({
      input: [
        {
          fieldName: 'entityType',
          comparator: ComparatorOperator.EQUALS,
          fieldValue: 'GOAL',
        },
      ],
    });
    const variables: VariablesOf<GoalSettingsViewQueryType> = {
      id: context.workspace?.globalId ?? '',
      workspaceUuid: context.workspace?.UUID ?? '',
      tql: fieldListTql,
    };

    return {
      query: GoalSettingsViewQuery,
      variables,
    };
  },
});
